import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { groupByMonth, getLimitDate, getDateLabels, countList, sumList, firstYear, yearsListOption, formatNumbers } from './statsFunctions';

import { Card, Grid, Box, Typography } from '@material-ui/core';
import { InputSelectNative } from '../../../../../commonModules/interface/form-input-inline';
import HighChartStack from '../../../../../commonModules/interface/Charts/HighChartStack';


class StackedStats extends Component {
    state = { 
        year: new Date().getFullYear(),
        operation: "payg",
    }

    filterList = () => {
        const { history } = this.props;
  
        let dateLimit = getLimitDate("year", this.state.year)
        let endYear = parseInt(this.state.year)+1
        console.log('====================================');
        console.log({history, dateLimit, endDate : new Date(endYear, 0, 1)});
        console.log('====================================');
        let list = Object.values(history).filter( item => 
            new Date(item.history_date) > dateLimit &&
            new Date(item.history_date) < new Date(endYear, 0, 1) &&
            item.operation == this.state.operation
        )

        let nbPerCatlist = countList(list, "history_product")
        let topCats = Object.keys(nbPerCatlist).sort( (a, b) => nbPerCatlist[b] - nbPerCatlist[a])

        return {list, topCats}
    }
    calcData = () => {
        const { PRODUCTS } = this.props;
        let sum = {}
        let series = []
        let bckg = []
        let average = []
        let formatted = {}
        let alpha = 80
        let total = 0

        let info = this.filterList()
        
        let list = info.list
        let catList = info.topCats
        let dateLabels = getDateLabels("year", this.state.year)
        let categories = groupByMonth(list, "history_date")
        // let categories = this.props.filter_period === "year" ? groupByMonth(list, "history_date") : groupByDate(list, "history_date")

        dateLabels.forEach( date => {
            sum[date] = categories[date] ? sumList(categories[date], "history_product", "history_quantity") : {}
        })
        
     
        catList.forEach(cat => {
            Object.values(sum).forEach( data => {
                if(!formatted[cat]){
                    formatted[cat] = []
                }
                formatted[cat].push(data[cat] || null)
            })
        })
        Object.keys(formatted).forEach( prodID => {
            series.push({
                name: !isEmpty(PRODUCTS) && PRODUCTS[prodID] && 
                    `${PRODUCTS[prodID].name}`,
                data: formatted[prodID],
            })

            total += formatted[prodID].reduce((prev, curr) => prev + curr )

            // if (bckg.includes(PRODUCTS[prodID].category_color)) {
            //     let alphaStr = "."+alpha
            //     // let color = hex2rgba(PRODUCTS[prodID].category_color, alphaStr)
            //     bckg.push(color)
                
            //     alpha = alpha >= 40 ? alpha - 20 : alpha
            // } else {
            //     bckg.push(PRODUCTS[prodID].category_color)
            // }
            
        })
 
        console.log('====================================');
        console.log({categories, series, bckg, sum, formatted, list});
        console.log('====================================');
        return {categories : dateLabels, series, bckg, total}
    }

    render() {
        const { history, PRODUCTS, noDateFilter } = this.props;
        let info_stack = !isEmpty(history) && !isEmpty(PRODUCTS) ? this.calcData() : {}
        const TITLE = {
            "payg": "Ventes",
            "commercial": "Reappros",
            "rectif": "Retours"
        }
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        {/* <Box p={2}> */}
                            <InputSelectNative
                                labelWidth={60}
                                onChange={ (e) => this.setState({ year: e.target.value })}
                                value={this.state.year}
                                label="Année"
                                options={yearsListOption()}
                                // options={[
                                //     <option>{new Date().getFullYear()}</option>,
                                //     <option>{firstYear}</option>
                                // ]}
                            />
                 
                    </Grid>
                    <Grid item xs={6}>
                        <InputSelectNative
                            // labelWidth={60}
                            onChange={ (e) => this.setState({ operation: e.target.value })}
                            value={this.state.operation}
                            label="Type Opération"
                            options={[
                                <option value="payg">Vente</option>,
                                <option value="commercial">Reappro</option>,
                                <option value="rectif">Retour</option>
                            ]}
                        />
                 
                    </Grid>
                </Grid>
                <Box textAlign="right">
                    <Typography variant="h6" color="secondary">
                        Total produits : <b>{formatNumbers.format(info_stack.total || 0) }</b>
                    </Typography>
                </Box>

                <Card>
                    <HighChartStack
                        title={`${TITLE[this.state.operation]} ${this.state.year} par produits`}
                        titleY="Montant FCFA"
                        type="column"
                        categories={info_stack.categories}
                        series={info_stack.series}
                        legend={false}
                        // colors={info_stack.bckg}
                    />
                    
                </Card>
            </Box>
        );
    }
}

export default StackedStats;

